module.exports = __webpack_public_path__ + "static/img/TRINITY.aa70d36.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/TRINITY.jpg
// module id = 7pLw
// module chunks = 0